import React from "react";

export const BMdrawer = () => {
  return <div>BM drawer</div>;
};
